import ReactGA from "react-ga4";
import CookieBanner from "../CookieBanner";
import React, {useState} from "react";
import useTrackPageView from "./useTrackPageView";

const GaTracker = () => {
  const [isTrackingAllowed, setIsTrackingAllowed] = useState(false)

  useTrackPageView(isTrackingAllowed)

  return (
    <>
      <CookieBanner
        onAccept={() => {
          setIsTrackingAllowed(true)

          if (process.env.NODE_ENV !== 'production') {
            return;
          }

          ReactGA.initialize("G-HNZ53SRECR", {
            gtagOptions: {
              send_page_view: false
            }
          });
        }}
      />
    </>
  )
}

export default GaTracker;